var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex d-print-none align-items-center border-bottom px-3 py-1 overflow-hidden flex-shrink-0 shadow-sm",class:_vm.className},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }